import React, {useEffect, useState, useRef} from 'react';
import './Sidebar.css';
import apiClient from '../utils/apiClient';
import { useAuth } from '../hooks/useAuth';

const Sidebar = ({ activeMenu = 'dashboard', isOpen, onClose }) => {
  const { user } = useAuth();
  const abortControllerRef = useRef(null);
  const allMenuItems = [
    {
      id: 'dashboard',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-layout-dashboard text-white" aria-hidden="true"><rect width="7" height="9" x="3" y="3" rx="1"></rect><rect width="7" height="5" x="14" y="3" rx="1"></rect><rect width="7" height="9" x="14" y="12" rx="1"></rect><rect width="7" height="5" x="3" y="16" rx="1"></rect></svg>
      ),
      label: '대시보드',
      subtitle: '전체 현황 및 통계'
    },
    {
      id: 'customer-management',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-file-text text-gray-400" aria-hidden="true"><path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path><path d="M14 2v4a2 2 0 0 0 2 2h4"></path><path d="M10 9H8"></path><path d="M16 13H8"></path><path d="M16 17H8"></path></svg>
      ),
      label: '고객 생성',
      subtitle: '결제 고객 생성'
    },
    {
      id: 'alimtalk',
      icon: (
        <svg className="kakao-svg" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 640 640"><path d="M320 66.5C479.1 66.5 608 168.2 608 293.6C608 419 479.1 520.7 320 520.7C302.5 520.7 285.4 519.5 268.8 517.1C252.2 528.8 156.2 596.2 147.1 597.5C147.1 597.5 143.4 598.9 140.2 597.1C137 595.3 137.6 590.4 137.6 590.4C138.6 583.8 162.6 501.2 167 485.9C85.9 445.8 32 374.6 32 293.5C32 168.1 160.9 66.5 320 66.5zM118.2 225.7C109.2 225.7 101.9 233 101.9 242C101.9 251 109.2 258.3 118.2 258.3L144.1 258.3L144.1 357C144.1 365.8 151.6 372.9 160.7 372.9C169.8 372.9 177.3 365.8 177.3 357L177.3 258.3L203.2 258.3C212.2 258.3 219.5 251 219.5 242C219.5 233 212.2 225.7 203.2 225.7L118.1 225.7zM259 225.7C248.2 225.9 239.7 234.1 236.9 242.1L197.2 346.7C192.2 362.4 196.6 368.2 201.1 370.3C204.3 371.8 208 372.6 211.7 372.6C218.6 372.6 223.9 369.8 225.5 365.3L233.7 343.7L284.4 343.7L292.6 365.2C294.2 369.7 299.5 372.5 306.4 372.5C310.1 372.5 313.7 371.7 317 370.2C321.6 368.1 326 362.3 320.9 346.6L281.2 242.1C278.4 234.1 269.9 225.9 259 225.7zM439.9 225.7C430.7 225.7 423.3 233.2 423.3 242.3L423.3 356C423.3 365.2 430.8 372.6 439.9 372.6C449 372.6 456.5 365.1 456.5 356L456.5 319.8L462.3 314L501.2 365.6C504.4 369.8 509.2 372.2 514.5 372.2C518.1 372.2 521.6 371.1 524.5 368.9C528 366.2 530.3 362.3 530.9 357.9C531.5 353.5 530.4 349.1 527.7 345.6L486.8 291.4L524.7 253.6C527.3 251 528.6 247.4 528.4 243.5C528.2 239.6 526.4 235.9 523.5 233C520.4 229.9 516.2 228.1 512.1 228.1C508.5 228.1 505.3 229.4 502.9 231.8L456.6 278.2L456.6 242.5C456.6 233.3 449.1 225.9 440 225.9zM348.6 225.7C339.3 225.7 331.7 233.2 331.7 242.3L331.7 355.1C331.7 363.5 338.8 370.3 347.6 370.4L400.9 370.4C409.7 370.4 416.8 363.5 416.8 355.1C416.8 346.7 409.6 339.9 400.9 339.9L365.6 339.9L365.6 242.3C365.6 233.1 358 225.7 348.6 225.7zM275.6 314.3L242.4 314.3L259 267.2L275.6 314.3z"/></svg>
      ),
      label: '알림톡 관리',
      subtitle: '알림톡 내용 관리'
    },
    {
      id: 'admin',
      icon: (
        <svg class="block size-full" fill="none" preserveAspectRatio="none" viewBox="0 0 24 24" width="20" height="20"><g id="shield-half"><path d="M12 3C14.3358 5.06658 17.3845 6.14257 20.5 6C20.9536 7.54302 21.0924 9.16147 20.9081 10.7592C20.7239 12.3569 20.2203 13.9013 19.4274 15.3005C18.6345 16.6998 17.5684 17.9254 16.2925 18.9045C15.0165 19.8836 13.5568 20.5962 12 21M12 3C9.66419 5.06658 6.61555 6.14257 3.50002 6C3.04642 7.54302 2.90763 9.16147 3.09189 10.7592C3.27615 12.3569 3.7797 13.9013 4.57261 15.3005C5.36553 16.6998 6.43163 17.9254 7.70756 18.9045C8.9835 19.8836 10.4432 20.5962 12 21M12 3V21" id="Vector" stroke="#9CA3AF" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path></g></svg>
      ),
      label: '관리자',
      subtitle: '사용자 관리',
      adminOnly: true
    }
  ];
  const [currentCustomer, setCurrentCustomer] = useState(0);

  // 사용자 등급에 따라 메뉴 필터링
  const menuItems = allMenuItems.filter(item => {
    if (item.adminOnly) {
      return user && user.grade === 'ADMIN';
    }
    return true;
  });

  const getMenuPath = (menuId) => {
    switch (menuId) {
      case 'dashboard':
        return '/Admin/dashboard';
      case 'customer-management':
        return '/Admin/manageUser';
      case 'customer-contents':
        return '/Admin/customer-contents';
      case 'alimtalk':
        return '/Admin/alimtalk';
      case 'admin':
        return '/Admin/config';
      default:
        return '/Admin/dashboard';
    }
  };

  const handleMenuClick = (e, menuId) => {
    e.preventDefault();
    const path = getMenuPath(menuId);
    window.location.href = path;
    
    // 모바일에서 메뉴 클릭 시 사이드바 닫기
    if (window.innerWidth <= 1024) {
      onClose();
    }
  };

  const userName = user?.name || user?.account || '사용자';
  const userEmail = user?.email || user?.account || 'user@example.com';
  const userGrade = user?.isAdmin ? '관리자' : '관리 계정';

  const handleCurrentCustomer = async () => {
    const response = await apiClient.get('/Customer/GetCurrentUser');
    if (response != null && response.data != null){
      setCurrentCustomer(response.data);
    }
  }

  useEffect(() => {
    handleCurrentCustomer();
    
    // 컴포넌트 언마운트 시 요청 취소
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [handleCurrentCustomer]);

  return (
    <>
      {/* 모바일 오버레이 */}
      {isOpen && (
        <div 
          className="sidebar-overlay"
          onClick={onClose}
        />
      )}
      
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        {/* 사용자 정보 */}
        <div className="sidebar-user">
          <div className="user-profile">
            <div className="user-icon">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                <circle cx="12" cy="7" r="4"></circle>
              </svg>
            </div>
            <div className="user-text">
              <span className="user-role">{userName}</span>
              <span className="user-level">{userGrade}</span>
            </div>
          </div>
          
          <div className="customer-count">
            <div className="customer-cont">
            <span className="count-label">관리 고객 수</span>
            <span className="count-number">{currentCustomer} 명</span>
            </div>
          </div>
        </div>

        {/* 메뉴 */}
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <a
              key={item.id}
              href={getMenuPath(item.id)}
              className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
              onClick={(e) => handleMenuClick(e, item.id)}
            >
              <div className="nav-icon">{item.icon}</div>
              <div className="nav-content">
                <span className="nav-label">{item.label}</span>
                <span className="nav-subtitle">{item.subtitle}</span>
              </div>
            </a>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar; 